import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import SiteContext from 'site/SiteContext';

export const SiteSearchableSection = ({ query, endpoint, children }) => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState({});

  const { displayLanguage } = useContext(SiteContext);

  let sectionActive = true;

  useEffect(() => {
    if (query) {
      const fn = async () => {
        setLoading(true);
        const nextResults = await doSearch(query, endpoint);     
        if (sectionActive)
        {
          setResults(nextResults);
          setLoading(false);
        }
      };
      fn();
    }

    return () => {
      sectionActive = false;
    };
  }, [query, endpoint]);

  const doSearch = async (data, url) => {
    try {
      // Convert data payload to query string parameters
      const queryParams = new URLSearchParams();
      
      const pageLimit = data.limit || 20;
      queryParams.append('size', pageLimit);

      if (data.term) queryParams.append('q', data.term);

      if (data.page) {
        const from = (data.page - 1) * (pageLimit);
        queryParams.append('from', from);
      }

      if (data.filter) {
        queryParams.append('contentType', data.filter);
      }

      if (displayLanguage && displayLanguage !== 'en') {
        queryParams.append('l', displayLanguage);
      }
      
      const urlWithParams = `${url}?${queryParams.toString()}`;
      const res = await axios.get(urlWithParams);

      if (sectionActive)
      {
        const pages = Math.ceil(res.data.pagination.total/pageLimit);
        const out = {
          hits: res.data.results,
          resultCount: res.data.pagination.total,
          pageCount: pages,
          currentPage: Math.floor(res.data.pagination.from / res.data.pagination.size) + 1,
          aggregations: res.data.aggregations || [],
        };
  
        return out;
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div>
      {
        children({
          results,
          loading,
        })
      }
    </div>
  );
};
